import React from 'react'
import clsx from 'clsx'
import FileInput from '../FileInput/FileInput'
import MinimalFileInput from '../MinimalFileInput/MinimalFileInput'
import InputText from '../InputText'

export const Step3 = ({
  otherClasses,
  state,
  setState,
  errorMessage,
  handleChange,
}) => {
  const step3Classes = clsx(
    otherClasses,
    ' px-6 lg:px-[40px] py-6 lg:py-[40px] flex flex-col'
  )
  return (
    <div className={step3Classes} data-testid="step3">
      <div className="flex flex-col gap-6 w-full mx-auto">
        <p className="font-work-sans text-[16px] lg:text-[20px] font-semibold text-primary_heading_color  leading-[27px]">
          Upload ID <span className="text-red-500">*</span>
        </p>
        <p className="text-primary_body_color text-sm font-work-sans">
          Please upload Front and Back of ID
        </p>
        <p className="text-primary_body_color text-sm font-work-sans">
          Person 1:
        </p>
        <MinimalFileInput
          fileLabel="front 1"
          warning={errorMessage?.license_front}
          state={state}
          setState={setState}
          fileNameToDisplay={state?.license_front?.name}
          inputName="license_front"
        />
        <MinimalFileInput
          fileLabel="back 1"
          warning={errorMessage?.license_back}
          state={state}
          setState={setState}
          fileNameToDisplay={state?.license_back?.name}
          inputName="license_back"
        />
        <p className="text-primary_body_color text-sm font-work-sans">
          Person 2:
        </p>
        <MinimalFileInput
          fileLabel="front 2"
          warning={errorMessage?.license_front02}
          state={state}
          setState={setState}
          fileNameToDisplay={state?.license_front02?.name}
          inputName="license_front02"
        />
        <MinimalFileInput
          fileLabel="back 2"
          warning={errorMessage?.license_back02}
          state={state}
          setState={setState}
          fileNameToDisplay={state?.license_back02?.name}
          inputName="license_back02"
        />
      </div>
      <InputText
        labelClasses="!text-base"
        label="Name of Real Estate Salesperson Who Helped You"
        name={'helpPerson'}
        value={state?.helpPerson || ''}
        onChange={handleChange}
        placeholder="Who helped you?"
        type="text"
      />
    </div>
  )
}

export default Step3
